import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import ScrollableAnchor from 'react-scrollable-anchor';

import './AlternateTextAndImageBlock.module.css';

AlternateTextAndImageBlock.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
};


function AlternateTextAndImageBlock({ data }) {
  const { title, text, image } = data;

  return (
    <ScrollableAnchor id={data.id}>
      <section styleName="TextAndImageBlock">
        <div styleName="img">
          <Img sizes={
            {
              ...image.sizes,
              base64: image.sqip.dataURI,
            }}
          />
        </div>
        <div styleName="text">
          <h2>{ title }</h2>
          <p>{ text }</p>
        </div>
      </section>
    </ScrollableAnchor>
  );
}

export default AlternateTextAndImageBlock;



// WEBPACK FOOTER //
// ./src/components/AlternateTextAndImageBlock/AlternateTextAndImageBlock.js